module.exports = __webpack_public_path__ + "static/media/united-states.dd65850c.svg";